/**
 * Sprint 23.8 — workspace-home formatting helpers. Small, shared by the hero
 * sections + sidebar so relative time / money / dates read consistently.
 */

/** "just now" / "3m" / "2h" / "5d" from an age in seconds. */
export function formatAge(seconds: number | null | undefined): string {
  if (seconds == null || seconds < 0) return "";
  const m = Math.floor(seconds / 60);
  if (m < 1) return "just now";
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h`;
  return `${Math.floor(h / 24)}d`;
}

/** Short date — "12 Mar" — for the meta row + sidebar. */
export function formatSince(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, { day: "numeric", month: "short" });
}

/** "$3.40" — two-decimal USD. */
export function formatMoney(n: number): string {
  return `$${n.toFixed(2)}`;
}
